export enum CommissionBasedOn {
  Stake = "stake",
  GainPercentage = "gainPercentage",
  GainDecreasing = "gainDecreasing",
}
